
import ControllerAddress from 'Controllers/checkout/ControllerAddress'
import ControllerOrderHistory from 'Controllers/user/ControllerOrderHistory'
import ControllerWishlist from 'Controllers/user/ControllerWishlist'
import ControllerProduct from 'Controllers/ControllerProduct'
import ControllerProductList from 'Controllers/ControllerProductList'
import ControllerChangePassword from 'Controllers/user/ControllerChangePassword'
import WishListProducts from '../ecommerce/shop/wishList/wishListProducts'
import Spinner from '../ui/Spinner'
import OrderProduct from '../ecommerce/shop/product/orderProduct'

export default {
  components: {
    WishListProducts,
    ControllerOrderHistory,
    ControllerWishlist,
    ControllerAddress,
    ControllerProduct,
    ControllerProductList,
    ControllerChangePassword,
    Spinner,
    OrderProduct,
  },
  fetch({ redirect, route }) {
    if (!this.$auth.user) {
      redirect('/prijava')
    }
  },
  data() {
    return {
      type: false,
      narudba: null,
      fullOrderBasePrice: 0,
      tab: 'Pregled računa',
      showProfileEditForm: false,
      historyOrder: false,
      wishListCustom: false,
      orderDetails: false,
      profileViewCustom: false,
      changeTextPassCheck: false,
      productsLoaded: false,
      orderProducts: null,
      orderProductsArray: [],
      paymentStatusCommons: {
        scheduled: 'Zakazano',
        notPaid: 'Nije plaćeno',
        paid: 'Plaćeno',
        ready: 'Spremno',
        ptPaid: 'Djelomićno plaćen',
        notApplicable: 'Nije moguće aplicirati',
        transferred: 'Transferirano',
        overpaid: 'Preplaćeno',
      },
      deliveryStatusCommons: {
        ready: 'Spremno',
        confirmed: 'Potvrđeno',
        notSent: 'Nije poslano',
        sent: 'Poslano',
        scheduled: 'Zakazano',
      },
    }
  },
  computed: {
    previewedItemIssuedFrom() {
      return (
        this.narudba &&
        this.narudba.extendedDetails &&
        this.narudba.extendedDetails.issuedFrom &&
        this.narudba.extendedDetails.issuedFrom.length &&
        this.narudba.extendedDetails.issuedFrom[0]
      )
    },
    previewedItems() {
      return (
        this.narudba &&
        this.narudba.extendedDetails &&
        this.narudba.extendedDetails.items
      )
    },
  },
  watch: {
    tab: {
      handler(v) {
        if (this.$route.query && this.$route.query.tab) {
          this.$router.replace({
            ...this.$router.currentRoute,
            query: {
              search: '' || undefined,
            },
          })
        }
        this.showProfileEditForm = false
        if (v !== 'povijest-narudbi') {
          this.narudba = null
          this.orderDetails = false
        }
      },
      deep: true,
    },
    '$route.query.tab': {
      handler() {
        this.setCurrentTab()
      },
    },
    '$router.path': {
      handler() {
        this.setCurrentTab()
      },
    },
    '$auth.loggedIn': {
      handler() {
        if (!this.$auth.loggedIn) {
          this.logout()
          this.$toast.success('Uspješna odjava!')
        }
      },
    },
    narudba: {
      handler(v) {
        this.productsLoaded = false
        this.orderProductsArray.splice(0, this.orderProductsArray.length)
        this.orderProducts = null
        if (v && v.items && v.items.length) {
          this.orderProducts = [...v.items]
          this.productsLoaded = true
        }
      },
    },
    orderProducts(v) {
      this.fullOrderBasePrice = 0
      if (v && v.length) {
        v.map((e) => {
          if (!e.finalNetPrice) return false
          this.fullOrderBasePrice += e.finalNetPrice
        })
      }
    },
    orderDetails(v) {
      if (v) {
        // this.fetchOrderProducts()
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
  mounted() {
    this.setCurrentTab()
    // this.fetchOrderProducts()
    setTimeout(() => {
      if (window && window.innerWidth <= 1023) {
        this.tab = ''
      }
    }, 200)
  },
  methods: {
    submitProfileForm(submit) {
      submit()
    },
    submitedProfileForm() {
      this.$toast.success('Podatci uspješno spremljeni!')
      this.showProfileEditForm = false
    },
    showChangePasswordMessage() {
      this.$toast.success('Lozinka uspješno promjenjena!')
    },
    calculateShippingTax(price, tax) {
      if (!price) return 0
      return price + price * (tax / 100)
    },
    currencyNameSwitch(price) {
      if (!price) return
      return price.replace('HRK', 'Kn')
    },
    async getSingleProduct(id) {
      return await this.$api.product.web.get({
        id,
        storeId: this.$application.store.storeID,
        currency: this.$application.currency.label,
      })
    },
    async fetchOrderProducts() {
      try {
        const data = []
        if (this.orderProducts && this.orderProducts.length) {
          for (const el of this.orderProducts) {
            if (el.item && el.item.id) {
              const res = await this.getSingleProduct(el.item.id)
              if (res) data.push(res)
            }
          }
          if (data && data.length) {
            const result = await Promise.all(data)
            if (result) {
              this.orderProductsArray = result
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    setCurrentTab() {
      if (this.$route.query && this.$route.query.tab) {
        this.tab = this.$route.query.tab
      }
    },
    returnCountryName(countries, currentCountryCode) {
      if (countries && countries.length && currentCountryCode) {
        const country = countries.filter((el) => el.iso === currentCountryCode)
        if (country && country.length) {
          return country[0]?.name || ''
        } else {
          return 'Država nije postavljena'
        }
      } else {
        return 'Nema države za prikazati'
      }
    },
    logout() {
      this.$auth.logout()
    },
  },
}
